module.exports = __webpack_public_path__ + "img/vonestis_spa_01.ffe3ae33.jpg";